import { translationsApi } from '@/app/shared/services/apis/translationsApi.service';
import messages from '@intlify/unplugin-vue-i18n/messages';
import { createI18n, useI18n as vueUseI18n } from 'vue-i18n';
import { setI18n } from '@fifa-bsm/bo-frontend-shared/i18n';

export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages,
});

setI18n(i18n);

export async function loadOverrides(locale, _i18n = i18n) {
    const overrides = await translationsApi.getFrontendOverrides({
        language: locale,
    });
    if (overrides.length) {
        const newMessages = {};
        const addKey = (_messages, keys, index, value) => {
            if (!_messages[keys[index]]) {
                _messages[keys[index]] = {};
            }
            if (keys[index + 1]) {
                addKey(_messages[keys[index]], keys, index + 1, value);
            } else {
                _messages[keys[index]] = value;
            }
        };
        overrides.forEach((override) => {
            const key = override.key;
            const keys = key.split('.');
            addKey(newMessages, keys, 0, override.translation);
        });
        _i18n.global.mergeLocaleMessage(locale, newMessages);
    }
}

export const t = i18n.global.t;

export const useI18n = vueUseI18n;

if (import.meta.hot) {
    import.meta.hot.accept('@intlify/unplugin-vue-i18n/messages', (module) => {
        Object.entries(module.default).forEach(([locale, data]) => {
            i18n.global.setLocaleMessage(locale, data);
        });
    });
}
